import React from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import DashedLine from './dashedLine';

const OrdersSummaryChart = () => (
  <Card className="h-100">
    <CardBody>
      <h5 className="mb-3">Return Summary</h5>
      <Row
        className="d-flex justify-content-between mb-2 bg-soft-light border-light m-0"
        style={{
          borderStyle: 'dotted',
          borderTopWidth: 1,
          borderBottomWidth: 1,
          borderLeftWidth: 0,
          borderRightWidth: 0,
        }}
      >
        <Col className="d-flex flex-column align-items-center justify-content-center p-3">
          <div className="fw-bold font-size-11">7,585</div>
          <div className="text-muted font-size-10">Orders</div>
        </Col>
        <Col
          className="d-flex flex-column align-items-center justify-content-center border-light p-3"
          style={{
            borderStyle: 'dotted',
            borderTopWidth: 0,
            borderBottomWidth: 0,
            borderLeftWidth: 1,
            borderRightWidth: 1,
          }}
        >
          <div className="fw-bold font-size-11">$22.89k</div>
          <div className="text-muted font-size-10">Earnings</div>
        </Col>
        <Col
          className="d-flex flex-column align-items-center justify-content-center border-light p-3"
          style={{
            borderStyle: 'dotted',
            borderTopWidth: 0,
            borderBottomWidth: 0,
            borderLeftWidth: 1,
            borderRightWidth: 1,
          }}
        >
          <div className="fw-bold font-size-11">367</div>
          <div className="text-muted font-size-10">Refunds</div>
        </Col>
        <Col className="d-flex flex-column align-items-center justify-content-center p-3">
          <div className="fw-bold font-size-11 text-success">18.92%</div>
          <div className="text-muted font-size-10">Conversation Ratio</div>
        </Col>
      </Row>
      {/* Replace this div with your chart component */}

      <DashedLine />
    </CardBody>
  </Card>
);

export default OrdersSummaryChart;
